'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = require('babel-helper-vue-jsx-merge-props');

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _eventInterceptor = require('../../../utils/event-interceptor');

var _eventInterceptor2 = _interopRequireDefault(_eventInterceptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElSelectInput',
  componentName: 'ElSelectInput',
  components: {
    EventInterceptor: _eventInterceptor2.default
  },
  props: {
    value: [String, Number],
    addon: [String, Number, Boolean],
    options: {
      type: Array,
      default: []
    }
  },
  methods: {
    getStrLen: function getStrLen(str) {
      return (0, _from2.default)(str).reduce(function (len, char) {
        return len + (char.charCodeAt(0) <= 128 ? 0.5 : 1);
      }, 0);
    },
    calcSelectWidth: function calcSelectWidth() {
      var _this = this;

      var el = this.$el.querySelector('input');
      var maxLength = Math.max.apply(Math, (0, _toConsumableArray3.default)(this.options.map(function (option) {
        return _this.getStrLen(option.label);
      })));

      var _getComputedStyle = getComputedStyle(el),
          fontSize = _getComputedStyle.fontSize,
          letterSpacing = _getComputedStyle.letterSpacing;

      el.style.width = maxLength * (parseInt(fontSize, 10) || 0 + parseInt(letterSpacing, 10) || 0) + 47 + 'px';
    }
  },
  mounted: function mounted() {
    this.calcSelectWidth();
  },
  render: function render() {
    var h = arguments[0];

    var namespace = 'el-select-input';
    var _$listeners = this.$listeners,
        updateAddon = _$listeners['update:addon'],
        otherListeners = (0, _objectWithoutProperties3.default)(_$listeners, ['update:addon']);


    return h(
      'div',
      { 'class': namespace },
      [h(
        'event-interceptor',
        null,
        [h(
          'el-select',
          { 'class': namespace + '__select', attrs: { value: this.addon,
              placeholder: '' },
            on: {
              'input': updateAddon
            }
          },
          [this.options.map(function (option) {
            return h(
              'el-option',
              { props: option },
              []
            );
          })]
        )]
      ), h(
        'el-input',
        (0, _babelHelperVueJsxMergeProps2.default)([{ 'class': namespace + '__input', attrs: { value: this.value
          }
        }, { props: this.$attrs, on: otherListeners }]),
        []
      )]
    );
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/select-input/src/select-input.js
// module id = 303
// module chunks = 0